import { Typography, Stack, Link } from '@mui/material';
import { AuthentificationFormsConfirmSignUp } from '@scorenco/components';
import {
  AuthentificationState,
  useAmplifyServiceContext,
  useTranslation,
} from '@scorenco/core';

import { T_KEYS } from '../../../translations';

const AuthentificationConfirmSignUp = () => {
  const { t } = useTranslation();
  const { changeState } = useAmplifyServiceContext();

  return (
    <>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="baseline"
        mb={3}
      >
        <Typography variant="h2" textAlign="left">
          {t(T_KEYS.AUTHENTIFICATION_CONFIRM_SIGN_UP_TITLE)}
        </Typography>
        <Link
          onClick={() => {
            changeState({
              authState: AuthentificationState.SignUp,
            });
          }}
        >
          {t(T_KEYS.BACK)}
        </Link>
      </Stack>

      <Stack gap={2} alignItems="stretch">
        <AuthentificationFormsConfirmSignUp />
      </Stack>
    </>
  );
};

export default AuthentificationConfirmSignUp;
